.base {
}

.link {
	composes: interactive from './base.module.css';
	font: var(--lp-text-body-2-regular);
	outline: none;
	border-radius: var(--lp-border-radius-regular);
	text-decoration: none;

	&[data-hovered] {
		text-decoration: underline;
	}

	&[data-pressed] {
		color: var(--lp-color-text-interactive-active);
	}

	&[data-disabled]:not([data-current]) {
		cursor: not-allowed;
		color: var(--lp-color-text-interactive-disabled);
	}

	&[data-current] {
		cursor: default;
		font: var(--lp-text-body-2-semibold);
	}

	&[data-focus-visible] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: 0;
		z-index: 1;
	}
}

.default {
	composes: link;
	color: var(--lp-color-text-interactive-base);
}

.subtle {
	composes: link;
	color: var(--lp-color-text-ui-secondary);
}
